module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-dash-fill-65109f2e.svg";